export default {
  billingMonths: [],
  billingPlan: {},
  status: {},
  pricingPlan: null,
  creditCards: []
};
